import { Component, OnInit, OnChanges, Input, SimpleChanges } from '@angular/core';

import { Aka } from '../../../models/aka';

import { AkaService } from '../../../services/contacts/aka.service';
import { ModalService } from '../../../services/common/modal.service';
import { NotyService } from '../../../services/common/noty.service';

@Component({
  selector: 'app-aka-index',
  templateUrl: './aka-index.component.html',
  styleUrls: ['./aka-index.component.scss'],
})
export class AkaIndexComponent implements OnInit, OnChanges {
  /**
   * Contact id from parent component
   */
  @Input() contactId: number;

  /**
   * AKA list
   * @type {Array<Address>}
   */
  akas: Array<Aka> = [];

  /**
   * Indicates if AKAs are being loaded
   * @type {boolean}
   */
  loadingAkas: boolean = false;

  /**
   * Indicates if new address form is to be showed
   * @type {boolean}
   */
  showNewAkaForm: boolean = false;

  /**
   * Sortable options of AKAS sorting using Angular-sortablejs
   * @type {any}
   */
  sortableOptions: any = {
    chosenClass: 'sortable-chosen',
    dragClass: 'sortable-drag',
    ghostClass: 'sortable-ghost',
    handle: '.alias-sort-handle',
    onUpdate: (event: any) => {
      this.updateAkasPosition();
    },
  };

  /**
   * Inject dependencies
   * @param {AkaService}   private akaService   Service for AKAs resource
   * @param {ModalService} private modalService Service for modals
   * @param {NotyService}  private notyService  Service for UI notifications
   */
  constructor(private akaService: AkaService, private modalService: ModalService, private notyService: NotyService) {}

  // Component lifecycle methods

  /**
   * Called on Component initialization
   */
  ngOnInit() {}

  /**
   * Called when component variables change
   * @param {SimpleChanges} changes changes containing all variables changed
   */
  ngOnChanges(changes: SimpleChanges) {
    if (changes.contactId && changes.contactId.currentValue) this.loadAkas();
  }

  /**
   * Delete AKA
   * @param {Aka} aka AKA to delete
   */
  deleteAka(aka: Aka, index: number) {
    this.modalService.confirmDialogComponent.confirmButtonClasses = 'btn btn-danger';
    this.modalService.confirmDialogComponent.open(`<p>Delete AKA - <strong class='text-danger'>${aka.name}</strong></p>`).result.then(
      (result) => {
        this.modalService.confirmDialogComponent.confirmButtonClasses = 'btn btn-primary';
        if (result == 'confirmed') {
          aka.deleting = true;
          this.akaService
            .delete(aka.id)
            .then((response_json) => {
              aka.deleting = false;
              this.notyService.notify(`AKA deleted ${aka.name}`, 'warning');
              this.akas.splice(index, 1);
            })
            .catch(() => {
              aka.deleting = false;
              this.notyService.notify('Error deleting AKA', 'error');
            });
        }
      },
      (reason) => {
        this.modalService.confirmDialogComponent.confirmButtonClasses = 'btn btn-primary';
      }
    );
  }

  /**
   * Form saved
   * @param {boolean} event Indicates if formed saved successfully
   */
  formSaved(event: boolean, aka: Aka | null = null) {
    if (event && !aka) {
      if (!aka) this.loadAkas();
    } else if (!event && aka) this.loadAkas();
    if (!aka) this.showNewAkaForm = false;
    else aka.editing = false;
  }

  /**
   * Load AKAs
   */
  loadAkas() {
    this.loadingAkas = true;
    this.akaService
      .index({ contact_id: this.contactId })
      .then((response_json) => {
        this.loadingAkas = false;
        this.akas = response_json;
      })
      .catch(() => {
        this.loadingAkas = false;
      });
  }

  /**
   * Update positions of AKAs
   */
  updateAkasPosition() {
    let akaIds: Array<number> = [];
    for (let aka of this.akas) akaIds.push(aka.id);
    this.akaService
      .updatePositions(this.contactId, akaIds)
      .then((response_json) => {
        if (!response_json.success) this.notyService.notify('Error in sorting aliases', 'error');
      })
      .catch(() => {
        this.notyService.notify('Error in sorting aliases', 'error');
      });
  }
}
